import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { useLang } from "@/lib/lang";

export default function NotFound() {
    const { t } = useLang();
    return (
        <div className="min-h-screen bg-ink text-slate-900">
            <Navbar />
            <div className="max-w-2xl mx-auto px-6 pt-24 pb-24 text-center">
                <div className="mono-label mb-4">/ 404</div>
                <h1 className="font-display text-6xl md:text-7xl mb-4 tracking-tighter" data-testid="notfound-title">
                    {t("notfound.title")}
                </h1>
                <p className="text-slate-600 mb-10">{t("notfound.body")}</p>
                <Link to="/" className="btn-primary" data-testid="notfound-home-link">
                    {t("notfound.cta")}
                </Link>
            </div>
        </div>
    );
}
